<h2>Borrow more money</h2>
<form [formGroup]="stepFormGroup">
  <shared-form-field-wrapper
    label="How much more?"
    [formControl]="stepFormGroup.controls.loanAmountIncrease">
    <shared-input-number
      [type]="InputNumberType.CURRENCY"
      [formControl]="stepFormGroup.controls.loanAmountIncrease" />
    <shared-validation-message validation [control]="stepFormGroup.controls.loanAmountIncrease">
      <div min-message>
        Minimum is
        {{
          stepFormGroup.controls.loanAmountIncrease.errors?.min?.min
            | currency: "GBP" : "symbol" : "1.0-0"
        }}
      </div>
    </shared-validation-message>
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    label="What is the reason?"
    [formControl]="stepFormGroup.controls.reason">
    <shared-select
      placeholder="Select reason"
      [formControl]="stepFormGroup.controls.reason"
      [options]="smartSearchBorrowMoreReasons"
      [showLogo]="false" />
  </shared-form-field-wrapper>
  <div class="two-fields-form-row">
    <shared-form-field-wrapper
      label="Over what term?"
      [formControl]="stepFormGroup.controls.termInMonths">
      <shared-input-term [formControl]="stepFormGroup.controls.termInMonths" />
    </shared-form-field-wrapper>
    <shared-form-field-wrapper label="Current term">
      <span class="current-term">{{
        currentPropertyMortgageData?.mortgageTermRemaining | term
      }}</span>
    </shared-form-field-wrapper>
  </div>
  <div class="note" *ngIf="stepFormGroup.controls.loanAmountIncrease.value < 25000">
    <shared-icon icon="info" width="1.5rem" height="1.5rem" />
    <div>
      Lenders typically have a minimum new borrowing amount of
      {{ 25000 | currency: "GBP" : "symbol" : "1.0-0" }}. If you need less, your expert mortgage
      adviser will help find the best option for you and provide accurate guidance.
    </div>
  </div>
</form>
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()">
  <div class="stepper-content">
    <shared-labeled-value
      [valueStyle]="{ 'font-size': '1.5rem', 'margin-top': '0.5rem' }"
      [valueType]="ValueType.CURRENCY"
      [value]="currentPropertyMortgageData.mortgageRoundedOutstandingBalance"
      label="Current balance" />
    <shared-labeled-value
      [valueStyle]="{ 'font-size': '1.5rem', 'margin-top': '0.5rem' }"
      [valueType]="ValueType.CURRENCY"
      [value]="
        currentPropertyMortgageData.mortgageRoundedOutstandingBalance +
        +stepFormGroup.value.loanAmountIncrease
      "
      label="New total borrowing" />
    <p>
      Increasing your mortgage will change your monthly payments. Please choose an amount you can
      afford comfortably.
    </p>
  </div>
</cp-stepper>
